import React from 'react'
import { Link } from 'gatsby'
import { graphql } from 'gatsby'

const TransitionLink = props => {
  const config = {
    ...props
  }

  if (props.gaTarget) config['data-ga-target'] = props.gaTarget

  return <Link {...config} />
}

export { TransitionLink }

export const query = graphql`
  fragment Link on DatoCmsLink {
    id
    displayText
    url
    link {
      ... on DatoCmsPage {
        id
        path
      }
      ... on DatoCmsPost {
        id
        path
      }
    }
  }
`
